"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAssociationProfesionnelleTrads = void 0;
exports.EAssociationProfesionnelleTrads = {
    ANACOFI_CIF: "ANACOFI-CIF",
    Aucune_association: "Autre association",
    CNCEF: "CNCEF",
    CNCGP: "CNCGP",
    LA_COMPAGNIE_DES_CGP_CIF: "La Compagnie des CGP-CIF",
};
